














































import PartnerSelectBox from '@/components/partner/PartnerSelectBox.vue';
import {Vue, Component} from 'vue-property-decorator';
import { namespace} from 'vuex-class';
import { PutContractsMerchandisersRequest,GetContractsMerchandisersRequest, GetAdminsServiceMerchandisersResponse,GetAdminsServiceMerchandisersRequest, GetMallsResponse, Mall, Mds, PutContractsInfoRequest, GetPartnersRequest  } from 'supporter';

const mallModule = namespace('mall');

@Component({
  components: {
    PartnerSelectBox,
  }
})
export default class ChangeMd extends Vue {
  @mallModule.Getter('malls')
  private malls!: Mall[];

  @mallModule.Getter('mallsMds')
  private mallsMds!: Mds[];

  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<GetMallsResponse>;
  @mallModule.Action('fetchMallsMds') fetchMallsMds!: (mdsRequest) => Promise<GetAdminsServiceMerchandisersResponse>;

  private fetchMallMdsRequest:GetAdminsServiceMerchandisersRequest = {
    params: {
      mallNo: this.$route.query.mallNo as string
      }
    }
  private partnerName:string = '';
  private mallMdsOption: Mds[]= [];
  private mdCount:number = 0;
  private newMdNo:number = 0;  
  private mdInfo;

  private getNewMdName(){
    return this.mallsMds.find(({adminNo})=>adminNo === this.newMdNo)?.name ?? '';
  } 
  private parseMdInfo() {
    this.mdInfo = JSON.parse(sessionStorage.getItem('md-info'));
  }
  private successAlert(count:number, name:string){
    return alert(this.$t('PARTNER_POPUP_SUCCESS_MESSAGE', [count, name]))
  }

  private changeOptionIndex() {
     const mallsMdsMap= this.mallsMds.map(({name, id, adminNo})=>({
      name: `${name}(${id})`,
      adminNo,
      id,
    }))

    this.mallMdsOption = [...mallsMdsMap].sort((a,b)=>a.name>b.name?1:-1)
  }

  private async fetchPartnerName() {
     const request:GetPartnersRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo),
        chargeMdNo: Number(this.$route.query.chargeMdNo),
      }
    }
    const {data} = await this.$api.getPartners(request)
  
    const currentPartnerNo = this.$route.query.partnerNo ;
    const partnerName = data.contents.find(({partnerNo})=>partnerNo === Number(currentPartnerNo))?.partnerName ?? '';
    this.partnerName = partnerName;
  }

  private async fetchMdCount(){
    const request:GetContractsMerchandisersRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo),
        chargeMdNo: Number(this.$route.query.chargeMdNo),
        searchType: this.mdInfo.searchType,
        keyword: this.mdInfo.keyword,
        partnerStatus: this.mdInfo.partnerStatus,
        contractStatus: this.mdInfo.contractStatus,
        startDateTime: this.mdInfo.startDateTime,
        endDateTime: this.mdInfo.endDateTime,
        productRegistered: this.mdInfo.productRegistered,
      }
    }
    const {data} = await this.$api.getContractsMerchandisers(request)
    this.mdCount = data.mdCount; 
  }

  private async handleChangeMdClick() {
    if (!this.newMdNo){
      alert(this.$t('PARTNER_POPUP_ERR_MD_NULL'));
      return;
    }
    const request:PutContractsMerchandisersRequest = {
      data: {
        mallNo: Number(this.$route.query.mallNo),
        chargeMdNo: Number(this.$route.query.chargeMdNo),
        newMdNo: this.newMdNo, 
        searchType: this.mdInfo.searchType,
        keyword: this.mdInfo.keyword,
        partnerStatus: this.mdInfo.partnerStatus || null,
        contractStatus: this.mdInfo.contractStatus,
        startDateTime: this.mdInfo.startDateTime,
        endDateTime: this.mdInfo.endDateTime,
        productRegistered: this.mdInfo.productRegistered,
      }
    } 

    if(confirm(this.$t('PARTNER_POPUP_CHANGE_CONFIRM_MESSAGE') as string)){
      const {data} = await this.$api.putContractsMerchandisers(request)
      Number(data.contractUpdates) !== 0 && this.successAlert(data.contractUpdates, this.getNewMdName())
      if (this.$route.query && this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}()`);
      this.close();
      }
      sessionStorage.removeItem('md-info');
    } 
    return;
  }

  private async handleChangeMdNameClick() {
    
    if(!this.newMdNo){
      alert(this.$t('PARTNER_POPUP_ERR_MD_NULL'));
      return;
    }
    const request:PutContractsInfoRequest = {
      data: {
      partnerNo: Number(this.$route.query.partnerNo),
      contracts: [
				{
					commissionRate: Number(this.$route.query.commissionRate),
					contractNo: Number(this.$route.query.contractNo),
					promotionAgreed: Boolean(this.$route.query.promotionAgreed),
					merchandiserNo: this.newMdNo,
				}
			],}
    }

    if(confirm(this.$t('PARTNER_POPUP_CHANGE_CONFIRM_MESSAGE') as string)){
        const {data} = await this.$api.putContractsInfo(request)
        data.successCount && this.successAlert(data.successCount, this.getNewMdName())
        window.opener.location.reload();
        this.close();
    }
  }

  private async created() {
    await this.parseMdInfo();
    await this.fetchMalls();
    await this.fetchMallsMds(this.fetchMallMdsRequest);
    this.fetchPartnerName();
    this.fetchMdCount();
    this.changeOptionIndex();
  }

  private close() {
    window.close();
  }
}
